import { IconLock, IconPeople } from '@frameio/vapor-icons';

export const Icon = {
  Private: IconLock,
  Public: IconPeople,
};
